module.exports = __webpack_public_path__ + "img/xiaozhi_logo.618710dc.png";